export default __webpack_public_path__ + "static/media/407.edbd9e43.gif";